module.exports = __webpack_public_path__ + "static/img/bing.68ae7104.svg";